import type { Tokens } from '../../../../theming/types'

export default (config: { tokens: Tokens }) => {
  const { tokens } = config
  return {
    default: {
      wrap: {
        backgroundColor: tokens.bgColorDefault,
        borderRadius: '0 0 4px 4px',
        zIndex: 1,
      },
    },

    children: {
      wrap: {
        display: 'block',
        flex: '0 0 auto',

        '& > button': {
          display: 'inline-flex',
        },
      },
    },
  } as const
}
